
/* injects from baggage-loader */

'use strict';

const moduleContentEditable = angular.module('contentEditable.initializer', []);

moduleContentEditable.service('ContentEditable', [
  '$timeout', '$injector', 'ns', '$rootScope', ($timeout, $injector, ns, $rootScope) => {
    let Y;

    return {
      init: function(y) {
        Y = y;
      },
      clearPaste: function(e) {
        var newDiv, text;
        e.preventDefault();

        if (e.originalEvent.clipboardData) {
          text = e.originalEvent.clipboardData.getData('text/plain');
        } else {
          text = window.clipboardData.getData('text');
        }

        if (text.length > 0) {
          newDiv = document.createElement("div");
        }

        newDiv.innerHTML = text;
        document.execCommand("insertHTML", false, newDiv.textContent);
        return false;
      },
      setToValue: function(obj, value, path) {
        var i;
        path = path.split('.');
        i = 0;
        while (i < path.length - 1) {
          obj = obj[path[i]];
          i++;
        }
        obj[path[i]] = value;
      },
      /**
       * Очистка html от лишних блоков
       * @param value
       * @param classesForRemove
       * @returns {*}
       */
      htmlClearClasses: function (value, classesForRemove = []) {
        const $value = $('<div/>').html(value);

        if (classesForRemove.length > 0) {
          classesForRemove.map((selector) => {
            const $elem = $value.find(selector);

            if ($elem.length > 0) {
              $elem.remove();
            }
          });
        }

        return $value.html();
      },
      htmlDecode: function (value) {
        return $('<div/>').html(value).text();
      },
      htmlEncode: function(value) {
        return $('<div/>').text(value).html();
      },
      bind: function(layout, value, id) {
        if (id === null || id === undefined) {
          id = false;
        }

        const self = this;

        if (id) {
          layout = Y.one('[data-block-id=\'' + id + '\']');
        }

        layout.all('[contenteditable]').each(function(element) {
          const block = element.ancestor(ns.blockClass);

          if (!block.widget) {
            return false;
          }

          if (block.widget.type === 'text') {
            return false;
          }

          if (block.widget.type !== 'code') {
            $(element._node).unbind('paste', self.clearPaste);
            $(element._node).on('paste', self.clearPaste);
          }

          element.setAttribute('contenteditable', value);

          if (value) {
            element.on('valuechange', function(e) {

              let newVal = e.newVal;

              if (block.widget.type === 'subscribe_form' || block.widget.type === 'list' || block.widget.type === 'button') {
                newVal = self.htmlClearClasses(e.newVal, [
                    '.strwf_button__additional-text',
                    '.strwf_button__icon'
                  ]
                );
              }

              if (block.widget.type === 'code') {
                newVal = self.htmlDecode(e.newVal);
              }

              self.setToValue(block.widget, newVal, element.getAttribute('data-access'));
              $rootScope.$apply();
            });
          } else {
            element.detach('valuechange');
          }
        });
      },
      destroy: function() {}
    };
  }
]);




// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/contentEditable/contentEditable.initializer.js